import React from 'react';
import Icon from '../ui/Icon';
import './AchievementCard.css';

// `achievement`: { id, label, description, held, progress?: {current, target} }.
// No unlock date is shown — v1 only knows current-held-state, not when it
// was reached (see docs/UI_UX_ARCHITECTURE.md §5/§12 for the persistence
// needed to add dates). `progress` (added Phase 3) is real evidence toward
// the same condition that unlocks it — never a separate guess.
const AchievementCard = ({ achievement }) => {
  const showProgress = !achievement.held && achievement.progress && achievement.progress.target > 0;
  const pct = showProgress ? Math.min(100, Math.round((achievement.progress.current / achievement.progress.target) * 100)) : 0;

  return (
    <div className={`z-achievement-card ${achievement.held ? 'z-achievement-card--held' : 'z-achievement-card--locked'}`}>
      <div className="z-achievement-icon" aria-hidden="true">
        {achievement.held ? <Icon name="trophy" art size={40} /> : <Icon name="lock" size={26} />}
      </div>
      <span className="z-achievement-label">{achievement.label}</span>
      <span className="z-achievement-desc">{achievement.description}</span>
      {showProgress && (
        <>
          <div className="z-achievement-track"><div className="z-achievement-fill" style={{ width: `${pct}%` }} /></div>
          <span className="z-achievement-progress-text">{achievement.progress.current} / {achievement.progress.target}</span>
        </>
      )}
    </div>
  );
};

export default AchievementCard;
